const firebaseConfig = {
    apiKey: "AIzaSyAiSldcV9azstrtA3CMqmeB4P-Lj-VK8k0",
    authDomain: "gym-extreme-firebae.firebaseapp.com",
    projectId: "gym-extreme-firebae",
    storageBucket: "gym-extreme-firebae.appspot.com",
    messagingSenderId: "137131056871",
    appId: "1:137131056871:web:10c48a1fd2b626690e8c42"
  };
  export default firebaseConfig